///<reference path='./baseTracking.class.ts'/>
'use strict';


namespace Core {

    class SalesForceTrackingPixel extends Core.BaseTracking {
        private baseUrl: string;
        public pixelUrl: string;

        constructor (
            $scope: ng.IScope,
            $rootScope: ng.IRootScopeService,
            private cookieService,
            $q: ng.IQService,
            $location: ng.ILocationService
        ) {
            super($scope, $rootScope, $q, $location);
        }

        protected notChangedRouteHandler(): void {
            this.pixelUrl = '';
        }

        protected notTrackedRouteHandler(): void {
            this.pixelUrl = '';
        }

        protected routeChanged(page: Core.IPageTrackingData): void {
            this.compileData(page)
                .then((data) => {
                    this.pixelUrl = this.createPixelUrl(this.baseUrl, data);
                });
        }

        protected cmsRouteChanged(page: Core.IPageTrackingData): void {
            this.compileData(page)
                .then((data) => {
                    if (data) {
                        this.pixelUrl = this.createPixelUrl(this.baseUrl, data);
                    } else {
                        this.pixelUrl = '';
                    }
                });
        }

        $onInit(): void {
            this._onInit();
        }

        private compileData(page) {
            const data = this.getCookiesData();
            if (!data) {
                return this.$q.reject();
            }
            data.pageName = page.name;
            data.label = page.label;
            data.dataSet = '';

            return this.addBookingData(data)
                .then(this.addLandingPageData.bind(this));
        }

        private addBookingData(data) {
            if (data.label && data.label === 'bookingComplete') {
                const bookingStorageObj = sessionStorage.getItem('BookingConfirmAdFormItem');
                const bookingObj = bookingStorageObj ? JSON.parse(bookingStorageObj) : {};
                const totalCost = parseInt(bookingObj.totalCost, 10);
                if (totalCost && !isNaN(totalCost)) {
                    const dataSet = `
                            <data_set>
                                <data 
                                    amt="${totalCost}" 
                                    unit="${TRPCONFIG.Domain.CurrencyCode}" 
                                    accumulate="true"/>
                            </data_set>
                        `;
                    data.dataSet = dataSet.replace(/\s(?=\s)/g, '');
                }
                return this.$q.when(data);
            }
            return this.$q.when(data);
        }

        private addLandingPageData(data) {
            let url = this.$location.absUrl();
            if (data.label === 'landingPage' && url.indexOf('.html') !== -1) {
                const regExpMatch = url.match(/([^/]+)\.html/);
                const pageNameLanding = regExpMatch && regExpMatch[1] ?
                    `LandingPage:${regExpMatch[1]}` : data.pageName;
                data.pageName = pageNameLanding;
            }
            return data;
        }

        private getCookiesData() {
            let res;
            const val = this.cookieService.get('salesforce');
            if (val) {
                try {
                    res = {};
                    val.split('&').map(el => res[el.split('=')[0]] = el.split('=')[1]);
                } catch(err) {
                    res = '';
                }
            }
            return res;
        }

        private createXml(params) {
            params.e = params.e || '';
            return `
            <system>
                <system_name>tracking</system_name>
                <action>conversion</action>
                <member_id>${params.mid}</member_id>
                <job_id>${params.j}</job_id>
                <email>${params.e}</email>
                <sub_id>${params.sfmc_sub}</sub_id>
                <list>${params.l}</list>
                <original_link_id>${params.u}</original_link_id>
                <BatchID>${params.jb}</BatchID>
                <conversion_link_id>1</conversion_link_id>
                <link_alias>${params.pageName}</link_alias>
                <display_order>1</display_order>
                ${params.dataSet}
            </system>
            `.replace(/(>|^)\s*(<|$)/g, '$1$2');
        }

        private createPixelUrl(url, params) {
            if (!url.endsWith('/')) {
                url = `${url}/`;
            }
            const xml = encodeURIComponent(this.createXml(params));
            return `${url}conversion.aspx?xml=${xml}`;
        }
    }

    angular
        .module('core')
        .directive('salesForceTrackingPixel', (): ng.IDirective => {
            return {
                restrict: 'E',
                controller: SalesForceTrackingPixel,
                controllerAs: 'sfCtrl',
                bindToController: {
                    baseUrl: '@'
                },
                template: `
                    <img ng-src="{{sfCtrl.pixelUrl}}" width="1" height="1"/>
                `
            };
        });
}
